//Library Imports
import React from "react";
import { Row, Col } from "antd";
import { RootState } from "store";
import styled from "styled-components";
import { useSelector } from "react-redux";
//Local Imports
import { formatConcepts } from "utils";
import DonutChart from "modules/Content/Shared/DonutChart";
import ContentEngagementList from "./ContentEngagementList";
import { getAllAnalyticsTab } from "modules/Analytics/utils";
import SearchField from "modules/Analytics/Shared/SearchField";
import BubbleChart from "modules/Analytics/Charts/BubbleChart";
import WordCloudGraph from "modules/Analytics/Charts/WordCloudGraph";
import ButtonRightIcon from "modules/Common/Components/ButtonRightIcon";
import ExportAnalyticsPopup from "modules/Analytics/Shared/ExportAnalyticsPopup";
// Icon Imports
import Send from "../../../../assets/img/icons/Send.svg";

const Highcharts = require("highcharts");
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);

interface IContentEngagement {
  setSearchedText: (value: string) => void;
  searchedText: string;
}

const ContentEngagement: React.FC<IContentEngagement> = (props: IContentEngagement) => {
  // Props
  const { setSearchedText, searchedText } = props;

  // Redux States
  const disableExportButton = useSelector((state: RootState) => state.accountsContentEngagement.exportButtonDisable);
  const engagementList = useSelector((state: RootState) => state.accountsContentEngagement.data);

  // Local variables
  const keywords = engagementList?.keywords;
  const entities = engagementList?.entities;
  const concepts = engagementList?.concepts;

  return (
    <Wrapper className="content-engagement">
      {concepts?.length > 0 || keywords?.length > 0 || entities?.length > 0 ? (
        <Row gutter={24} className="pt-4">
          {concepts?.length > 0 && (
            <Col span={"8"}>
              <DonutChart
                data={formatConcepts(concepts)}
                backgroundColor={"white"}
                title={"CONCEPTS"}
                width={530}
                height={400}
                highcharts={Highcharts}
                fontSize={28}
                fontStyle={"Roboto Slab"}
              />
            </Col>
          )}
          {keywords?.length > 0 && (
            <Col span={"8"}>
              <WordCloudGraph data={keywords} />
            </Col>
          )}
          {entities?.length > 0 && (
            <Col span={"8"}>
              <BubbleChart
                data={entities}
                highcharts={Highcharts}
                backgroundColor={"white"}
                width={630}
                height={430}
              />
            </Col>
          )}
        </Row>
      ) : null}
      <Row>
        <Col span={"24"}>
          <div className="search-field-container">
            <span className={"engagement-text"}>Content engagement:</span>
            <ul className="ul-parent">
              <li>
                <div className="scaled-width-35">
                  <SearchField
                    placeholder="Search"
                    handleSearch={setSearchedText}
                    reset={searchedText}
                  ></SearchField>
                </div>
              </li>
              <li>
                <ul className="ul-child">
                  <li className={`right`}>
                    <ButtonRightIcon
                      label="Export"
                      onClick={() => getAllAnalyticsTab("accounts_content", searchedText)}
                      icon={Send}
                      outlineClass="auto-width"
                      disable={disableExportButton}
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
      <ContentEngagementList searchedText={searchedText} setSearchedText={setSearchedText} />
      <ExportAnalyticsPopup page={"accounts_content"} searchedText={searchedText} />
    </Wrapper>
  );
};

export default ContentEngagement;

const Wrapper = styled.div`
  .search-field-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 32px;
  }
  .scaled-width-35 {
    width: 200px;
  }
  .engagement-text {
    font-size: 23px;
    line-height: 47px;
    color: #424b50;
    font-weight: 400;
    font-family: "Roboto Slab";
  }
  ul {
    list-style: none;
  }
  .ul-parent {
    display: flex;
  }
`;
